/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useState } from 'react';
import { Avatar, AvatarGroup } from '@mui/material';
import styled from '@emotion/styled';
import AttendeesListPopup from '../../../../AttendeesList';
import GroupUserSvgIcon from '../../../../../../../assets/SvgIcons/GroupUserSvgIcon';
import { generateRandomUUID } from '../../../../../../../libs/HelperContent';

const CustomAvatar = styled(Avatar)(() => ({
	width    : 24,
	height   : 24,
	fontSize : 'var(--pixel12)'
}));

const CustomAvatarGroup = styled(AvatarGroup)(() => ({
	'& .MuiAvatarGroup-avatar' : {
		width    : 24,
		height   : 24,
		fontSize : 'var(--pixel12)'
	}
}));

const AttendeesList = (props) =>
{
	const [ attendees, setAttendees ] = useState(false);
	const { form } = props;

	const handleAttendeesClose = () =>
	{
		setAttendees(false);
	};

	const handleAttendees = (e) =>
	{
		e.stopPropagation();
		setAttendees(true);
	};

	return (
		<>
			{/* <CustomAvatarGroup max={3} sx={{ cursor: 'pointer' }} onClick={handleAttendees}>
				{attendeesList?.map((item:any) =>
					(
						<CustomAvatar
							key={item?.userId}
							alt={item?.name ?? item?.email ?? ''}
							src={item?.userId ? `${process.env.REACT_APP_S3_BASE_URL}/profile/${item?.userId}_profile.jpeg}` : '/images/icons/defaultUser.svg'}
						/>
					))}
			</CustomAvatarGroup> */}
			<CustomAvatarGroup max={4} sx={{ cursor: 'pointer' }} onClick={handleAttendees}>
				{
					form?.metaData?.relations?.map(() => (
						<span key={generateRandomUUID()}>
							<Avatar alt='img' src='/broken-image.jpg' className='brdrRadius50' sx={{ width: 'var(--pixel24)', height: 'var(--pixel24)' }}>
								<GroupUserSvgIcon/>
							</Avatar>
						</span>
					))}
				{form?.metaData?.externalMembers?.map((item:any) =>
					(
						<CustomAvatar
							key={item?.userId}
							alt={item?.name ?? item?.email ?? ''}
							src={item?.userId ? `${process.env.REACT_APP_S3_BASE_URL}/profile/${item?.userId}_profile.jpeg` : '/images/icons/defaultUser.svg'}
						/>
					))}
			</CustomAvatarGroup>
			{/* </> */}
			{attendees &&
			<AttendeesListPopup
				list={form?.metaData?.externalMembers ?? []}
				attendees={attendees}
				meetingData={form}
				requestType={'webinar'}
				handleAttendeesClose={handleAttendeesClose}
				requestId={form?.meetingId}
			/>}
		</>
	);
};

export default AttendeesList;